import { Text } from '@components/ui';
import { Box, Divider, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ProfileMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  fullName: string;
  email?: string;
  phoneNumber?: string;
  userRole: string | null;
  onNavigate: (path: string) => void;
  onSignOut: () => void;
}

const menuItemSx = {
  fontSize: 14,
  py: 1,
};

export const ProfileMenu = ({
  anchorEl,
  onClose,
  fullName,
  email,
  phoneNumber,
  userRole,
  onNavigate,
  onSignOut,
}: ProfileMenuProps): JSX.Element => {
  const { t } = useTranslation();
  const openPath = (path: string): void => {
    onClose();
    onNavigate(path);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          mt: 1,
          bgcolor: 'background.paper',
          border: 1,
          borderColor: 'divider',
          minWidth: 240,
          borderRadius: 2,
        },
      }}
    >
      <Box sx={{ px: 2, py: 1.5 }}>
        {fullName ? <Text variant="label">{fullName}</Text> : null}
        {email ? (
          <Text
            variant="caption"
            tone="muted"
            sx={{ display: 'block', mt: 0.5 }}
          >
            {email}
          </Text>
        ) : null}
        {phoneNumber ? (
          <Text variant="caption" tone="muted" sx={{ display: 'block' }}>
            {phoneNumber}
          </Text>
        ) : null}
      </Box>
      <Divider />
      <MenuItem onClick={() => openPath('/personal-info')} sx={menuItemSx}>
        {t('nav.personalInformation')}
      </MenuItem>
      {userRole === 'buyer' ? (
        <MenuItem onClick={() => openPath('/payment-methods')} sx={menuItemSx}>
          {t('nav.paymentMethods')}
        </MenuItem>
      ) : null}
      <MenuItem onClick={() => openPath('/settings')} sx={menuItemSx}>
        {t('nav.settings')}
      </MenuItem>
      <MenuItem
        onClick={onSignOut}
        sx={{ ...menuItemSx, color: 'primary.main' }}
      >
        {t('common.signOut')}
      </MenuItem>
    </Menu>
  );
};
